import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInventoryGroup } from "src/models/Products/InventoryGroup.models";

interface InventoryGroupState {
  inventoryGroups: IInventoryGroup[];
  inventoryGroupToEdit: IInventoryGroup | null;
}

const initialState: InventoryGroupState = {
  inventoryGroups: [],
  inventoryGroupToEdit: null,
};

const inventoryGroupSlice = createSlice({
  name: "InventoryGroup",
  initialState,
  reducers: {
    setInventoryGroupList: (
      state,
      action: PayloadAction<IInventoryGroup[]>
    ) => {
      state.inventoryGroups = action.payload;
    },
    concatListInventoryGroup: (
      state: InventoryGroupState,
      action: PayloadAction<IInventoryGroup[]>
    ) => {
      state.inventoryGroups = [...state.inventoryGroups.concat(action.payload)];
    },
    setInventoryGroupToEdit: (
      state,
      action: PayloadAction<IInventoryGroup | null>
    ) => {
      state.inventoryGroupToEdit = action.payload;
    },
    addInventoryGroup: (state, action: PayloadAction<IInventoryGroup>) => {
      state.inventoryGroups.push(action.payload);
    },
    updateInventoryGroup: (state, action: PayloadAction<IInventoryGroup>) => {
      let itemIndex = state.inventoryGroups.findIndex(
        item => item.inventoryGroupId === action.payload.inventoryGroupId
      );
      if (itemIndex !== -1) state.inventoryGroups[itemIndex] = action.payload;
    },
    deleteInventoryGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.inventoryGroups.filter(
        item => item.inventoryGroupId !== action.payload
      );
      state.inventoryGroups = newArray;
    },
  },
});

export const {
  setInventoryGroupList,
  concatListInventoryGroup,
  setInventoryGroupToEdit,
  addInventoryGroup,
  updateInventoryGroup,
  deleteInventoryGroup,
} = inventoryGroupSlice.actions;

export default inventoryGroupSlice.reducer;
